// Generated by tools/gen_submodule.js 
module['exports'] = require("./lib/widgets");


//////////////////
// WEBPACK FOOTER
// ../~/sportinglife-react-common/widgets.js
// module id = 60
// module chunks = 0